import { DCImportFieldEnum as Fields } from 'Common/FieldEnum';
import { isNullOrUndefined } from 'util';
import {
  MatchTypeEnum,
  ColumnTypeEnum,
  ImportTypeEnum,
} from '../helpers/Constants';

export const getRequiredHeaders = formValues => {
  if (!formValues) {
    return [];
  }

  let headerMapping =
    formValues && !isNullOrUndefined(formValues[Fields.HeaderMapping])
      ? formValues[Fields.HeaderMapping]
      : [];
  let requiredHeaders = [];

  if (formValues[Fields.MatchOn] === MatchTypeEnum.StudentNumber) {
    requiredHeaders = [ColumnTypeEnum.StudentNumber];
  } else if (formValues[Fields.MatchOn] === MatchTypeEnum.SSN) {
    requiredHeaders = [ColumnTypeEnum.SSN];
  } else if (formValues[Fields.MatchOn] === MatchTypeEnum.StateNumber) {
    requiredHeaders = [ColumnTypeEnum.StateNumber];
  }

  if (formValues[Fields.UseAddressInFile]) {
    requiredHeaders = requiredHeaders.concat([
      ColumnTypeEnum.Address1,
      ColumnTypeEnum.City,
      ColumnTypeEnum.State,
      ColumnTypeEnum.Zip,
    ]);
  }

  if (formValues[Fields.CreateFamilies]) {
    const foundCaseNum = !(
      headerMapping.findIndex(
        header => header === ColumnTypeEnum.CaseNumber
      ) === -1
    );
    if (!foundCaseNum) {
      requiredHeaders = requiredHeaders.concat([
        ColumnTypeEnum.Address1,
        ColumnTypeEnum.ParentFirstName,
        ColumnTypeEnum.ParentLastName,
      ]);
      const foundAddress1 = !(
        headerMapping.findIndex(
          header => header === ColumnTypeEnum.Address1
        ) === -1
      );
      const foundParentFirstName = !(
        headerMapping.findIndex(
          header => header === ColumnTypeEnum.ParentFirstName
        ) === -1
      );
      const foundParentLastName = !(
        headerMapping.findIndex(
          header => header === ColumnTypeEnum.ParentLastName
        ) === -1
      );
      const foundZip = !(
        headerMapping.findIndex(header => header === ColumnTypeEnum.Zip) === -1
      );
      const foundCity = !(
        headerMapping.findIndex(header => header === ColumnTypeEnum.City) === -1
      );
      if (!foundZip && !foundCity) {
        requiredHeaders = requiredHeaders.concat([
          ColumnTypeEnum.City,
          ColumnTypeEnum.Zip,
        ]);
      } else if (!foundZip) {
        requiredHeaders = requiredHeaders.concat([ColumnTypeEnum.City]);
      } else if (!foundCity) {
        requiredHeaders = requiredHeaders.concat([ColumnTypeEnum.Zip]);
      } else {
        requiredHeaders = requiredHeaders.concat([
          ColumnTypeEnum.City,
          ColumnTypeEnum.Zip,
        ]);
      }

      if (
        !(
          foundAddress1 &&
          foundParentFirstName &&
          foundParentLastName &&
          (foundZip || foundCity)
        )
      ) {
        requiredHeaders = requiredHeaders.concat([ColumnTypeEnum.CaseNumber]);
      }
    } else {
      requiredHeaders = requiredHeaders.concat([ColumnTypeEnum.CaseNumber]);
    }
  }

  if (formValues[Fields.UseCaseTypeMapping]) {
    requiredHeaders = requiredHeaders.concat([ColumnTypeEnum.CaseType]);
  }

  requiredHeaders = requiredHeaders.filter(
    (element, index, self) =>
      index === self.indexOf(element) &&
      !getDisabledHeaders(formValues).includes(element)
  );

  return requiredHeaders;
};

export const getDisabledHeaders = formValues => {
  if (!formValues) {
    return [];
  }

  let disabledHeaders = [];

  if (
    [
      ImportTypeEnum.Headstart,
      ImportTypeEnum.Homeless,
      ImportTypeEnum.Runaway,
      ImportTypeEnum.Migrant,
    ].includes(formValues[Fields.ImportType])
  ) {
    disabledHeaders = disabledHeaders.concat([
      ColumnTypeEnum.CaseType,
      ColumnTypeEnum.CaseNumber,
    ]);
  }

  return disabledHeaders;
};



// WEBPACK FOOTER //
// ./src/pages/dcimport/helpers/Helpers.js